export default "__VITE_ASSET__qCbQTroz__"